export const voiceAIRouteNames = {
  aiAgentSettings: 'ai-agent-settings',
  aiAgentSettingsDefault: 'ai-agent-settings-default',
  aiAgentSettingsEditAgent: 'ai-agent-settings-edit-agent',
}
